export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500">
            <i className="ri-send-plane-line text-2xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">爆料投稿</h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            你有猛料？欢迎投稿！无论是文字、图片还是视频证据，每日爆料大赛期待你的参与。
            投稿内容经审核通过后将纳入大赛排名，优秀爆料者还可获得专属流量扶持与现金奖励。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-8">
            <div className="flex items-center gap-2 px-4 py-2.5 bg-background-100 rounded-lg border border-background-200/60 w-full sm:w-auto justify-center">
              <i className="ri-mail-line text-primary-500"></i>
              <span className="text-sm text-foreground-600">tougao@meiribaoliao.com</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2.5 bg-background-100 rounded-lg border border-background-200/60 w-full sm:w-auto justify-center">
              <i className="ri-wechat-line text-primary-500"></i>
              <span className="text-sm text-foreground-600">微信公众号: 每日爆料</span>
            </div>
          </div>

          <a
            href="#"
            className="inline-flex items-center px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-add-circle-line mr-2"></i>
            立即投稿参赛
          </a>
        </div>
      </div>
    </section>
  );
}